/**
 * Grido date picker plugin.
 * @link https://github.com/dangrossman/bootstrap-daterangepicker
 *
 * @author Petr Bugyík
 * @param {jQuery} $
 * @param {Window} window
 * @param {undefined} undefined
 */
;
(function($, window, undefined) {
    /*jshint laxbreak: true, expr: true */
    "use strict";

    window.Grido.Grid.prototype.onInit.push(function(Grido)
    {
        if ($.fn.daterangepicker === undefined) {
            console.error('Plugin "bootstrap-daterangepicker.js" is missing! Run `bower install bootstrap-daterangepicker` and load it.');
            return;
        } else if (window.moment === undefined) {
            console.error('Plugin "moment.js" required by "bootstrap-daterangepicker.js" is missing!');
            return;
        }

        var format = Grido.options.datepicker.format.toUpperCase();
        Grido.$element.on('focus', 'input.date', function() {
            $(this).daterangepicker(
            {
                singleDatePicker: true,
                showDropdowns: true,
                format: format,
                startDate: window.moment().subtract(29, 'days'),
                endDate: window.moment()
            });
        });
    });

})(jQuery, window);
